import React, { useEffect, useState } from 'react'
import UiNavbarTopSelect from "../../../../_uiComponents/form/UiNavbarTopSelect"
import { useDispatch } from 'react-redux';
import { selectDealerShip } from '../../../../../_redux/_actions';

const UiTopNavSelect = (props) => {

    const [selectedDealer, setSelectedDealer] = useState(null);

    const actionDispatch = useDispatch();

    const onChange = (item) => {
        setSelectedDealer(item);
        const selectDealer = props?.dealerships.find(dealer => dealer.dealerCode === item.value);
        actionDispatch(selectDealerShip(selectDealer));
    };

    useEffect(() => {
        if(selectedDealer === null){
            actionDispatch(selectDealerShip(props?.dealerships[0]));
        }
    },[])

  return (
   
        <UiNavbarTopSelect 
            options={props?.dealerOptions} 
            onChange={onChange}
            selectDealer={props.selectDealer}
            value={{ label: props?.dealerOptions[0].label, value: props?.dealerOptions[0].value }}
        />
  )
}

export default UiTopNavSelect